import { useLoaderData } from 'react-router'
import { useDocumentTitle } from '@/hooks/document-title'
import type { OssPackage } from '@/features/legal/oss-licenses'
import { AboutView } from './'

const testId = 'about'

export default function AboutViewContainer() {
  useDocumentTitle('About Taxfyle')

  const packages = useLoaderData<OssPackage[] | null>()

  return <AboutView packages={packages} testId={testId} />
}
